<template>
    <div class="SiteCallToAction">
        <h2>Digitalize your tickets today.</h2>
        <Button to="/signup" class="primary lg">Try DumpTek Free</Button>
    </div>
</template>

<script>
import AppStoreBadges from '@/components/AppStoreBadges';

export default {
    name: 'SiteCallToAction',

    components: { AppStoreBadges },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.SiteCallToAction {
    padding: 80px 0;
    text-align: center;

    h2 {
        @extend %display-subtitle;
        max-width: 600px;
        margin: 0 auto 30px;
    }
}
</style>
